export const API = "https://us-central1-setweb-api-9cb05.cloudfunctions.net/api"